import Icon from '$store/components/ui/Icon.tsx'
import { formatPrice } from '$store/sdk/format.ts'
import Image from 'apps/website/components/Image.tsx'
import Modal from 'site/components/ui/Modal.tsx'
import RenderHTML from 'site/components/ui/RenderHTML.tsx'
import { VisualProps } from 'site/loaders/PaymentMethods.ts'
import template from 'site/sdk/template.ts'
import { useId } from '../../sdk/useId.ts'

export interface Props {
    visuals: VisualProps[]
    currency: string
    modalTitle: string
    id: string
    pixDiscount?: number

    installments: Record<
        string,
        {
            billingDuration: number
            price: number
        }[]
    >
}

const ButtonShowMore = ({ id }: { id: string }) => {
    return (
        <>
            <input
                checked={false}
                class='hidden peer'
                data-has={true}
                type='checkbox'
                id={id}
            />

            <label
                class='text-[#FF5101] text-sm font-bold underline order-last cursor-pointer group hidden peer-checked:block'
                htmlFor={id}
            >
                Ver menos parcelas
            </label>

            <label
                class='text-[#FF5101] text-sm font-bold underline order-last cursor-pointer group peer-checked:hidden'
                htmlFor={id}
            >
                Ver mais parcelas
            </label>
        </>
    )
}

function PaymentMethods(
    { currency, visuals, modalTitle, id, installments, pixDiscount = 3 }: Props,
) {
    const pixPrice = installments.Pix?.[0]?.price ?? 0
    const boletoPrice = installments.Boleto?.[0]?.price ?? 0
    const amePrice = installments.AmeDigital?.[0]?.price ?? 0
    const picpayPrice = installments.PicPay?.[0]?.price ?? 0

    const torraInstallments = installments.Torra
    const othersInstallments = installments.Outros
    const idPaymenteMethods = useId()

    return (
        <Modal id={id} ariaLabel='Modal de formas de pagamento'>
            <div class='w-full max-w-[580px] absolute z-50'>
                <div class='w-full bg-primary-700 flex items-center h-12 text-white px-4'>
                    <span class='text-lg font-bold block ml-auto'>{modalTitle}</span>
                    <label
                        for={id}
                        class='block ml-auto p-2 cursor-pointer'
                        aria-label='Fechar o modal de formas de pagamento'
                    >
                        <Icon id='X' size={20} />
                    </label>
                </div>
                <div class='bg-white px-7 py-8 grid grid-cols-2 justify-evenly gap-y-10 overflow-y-auto h-full max-h-[calc(100vh-10em)]'>
                    {visuals.map(({ title, image, priceFormat, showMore }) => {
                        if (priceFormat.toLowerCase().includes('billingduration')) {
                            if (priceFormat.includes('{{torra') && !torraInstallments.length) {
                                return null
                            }

                            if (!othersInstallments.length) {
                                return null
                            }
                        }

                        if (/pixPrice/.test(priceFormat) && pixPrice === 0) return null
                        if (/boletoPrice/.test(priceFormat) && boletoPrice === 0) return null
                        if (/amePrice/.test(priceFormat) && amePrice === 0) return null
                        if (/picpayPrice/.test(priceFormat) && picpayPrice === 0) return null

                        const paymentMethodsID = `${idPaymenteMethods}-${title}`

                        return (
                            <div class='border-l border-l-neutral-4 even:pl-5 first:border-none [&:nth-last-child(2)]:border-none'>
                                <div class='flex items-center gap-x-2'>
                                    <Image
                                        src={image.src}
                                        alt=''
                                        width={Number(image.size.split('x')[0])}
                                        height={Number(image.size.split('x')[1])}
                                    />
                                    <span class='font-semibold text-neutral-0'>{title}</span>
                                </div>
                                <ul class='flex flex-col gap-y-4 mt-5'>
                                    {priceFormat.toLowerCase().includes('billingduration')
                                        ? (
                                            priceFormat.includes('{{torra')
                                                ? (
                                                    <>
                                                        {torraInstallments.map(
                                                            ({ price, billingDuration }, index) => (
                                                                <>
                                                                    <li
                                                                        class={'peer-data-[has=true]:hidden peer-checked:!block'}
                                                                    >
                                                                        <RenderHTML
                                                                            html={template(
                                                                                priceFormat,
                                                                                {
                                                                                    torraBillingDuration:
                                                                                        billingDuration
                                                                                            .toString(),
                                                                                    torraBillingIncrement:
                                                                                        formatPrice(
                                                                                            price,
                                                                                            currency,
                                                                                        ),
                                                                                },
                                                                            )}
                                                                            class='text-neutral-1 text-sm'
                                                                        />
                                                                    </li>
                                                                    {showMore?.active &&
                                                                        index ===
                                                                            (showMore.max ?? 0) -
                                                                                1 &&
                                                                        (
                                                                            <>
                                                                                <ButtonShowMore
                                                                                    id={paymentMethodsID}
                                                                                />
                                                                            </>
                                                                        )}
                                                                </>
                                                            ),
                                                        )}
                                                    </>
                                                )
                                                : (
                                                    <>
                                                        {othersInstallments.map(
                                                            ({ price, billingDuration }, index) => (
                                                                <>
                                                                    <li
                                                                        class={'peer-[checked:false]:hidden'}
                                                                    >
                                                                        <RenderHTML
                                                                            html={template(
                                                                                priceFormat,
                                                                                {
                                                                                    billingDuration:
                                                                                        billingDuration
                                                                                            .toString(),
                                                                                    billingIncrement:
                                                                                        formatPrice(
                                                                                            price,
                                                                                            currency,
                                                                                        ),
                                                                                },
                                                                            )}
                                                                            class='text-neutral-1 text-sm'
                                                                        />
                                                                    </li>

                                                                    {showMore?.active &&
                                                                        index ===
                                                                            (showMore.max ?? 0) -
                                                                                1 &&
                                                                        (
                                                                            <>
                                                                                <ButtonShowMore
                                                                                    id={paymentMethodsID}
                                                                                />
                                                                            </>
                                                                        )}
                                                                </>
                                                            ),
                                                        )}
                                                    </>
                                                )
                                        )
                                        : (
                                            <li>
                                                <RenderHTML
                                                    html={template(priceFormat, {
                                                        pixPrice: formatPrice(pixPrice),
                                                        pixDiscount,
                                                        boletoPrice: formatPrice(boletoPrice),
                                                        amePrice: formatPrice(amePrice),
                                                        picpayPrice: formatPrice(picpayPrice),
                                                    })}
                                                    class='text-neutral-1 text-sm'
                                                />
                                            </li>
                                        )}
                                </ul>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}

export default PaymentMethods
